<template>
  <v-container>
    <div class="tableTitle">日数</div>
    <v-layout grid-list-md align-center>
      <table>
        <tr>
          <th>暦日数</th>
          <td>{{ dateCounts.dates }}日</td>
        </tr>
        <tr>
          <th>所定休日日数</th>
          <td>{{ dateCounts.closedDay }}日</td>
        </tr>
        <tr>
          <th>有休日数</th>
          <td>{{ dateCounts.paidDayOff }}日</td>
        </tr>
        <tr>
          <th>特別有休日数</th>
          <td>{{dateCounts.mDay}} 日</td>
        </tr>
        <tr>
          <th>無休特別休暇日数</th>
          <td>{{ dateCounts.noPaidDayOff }}日</td>
        </tr>
        <tr>
          <th>欠勤日数</th>
          <td>{{ dateCounts.absence }}日</td>
        </tr>
        <tr>
          <th>所定出社日数</th>
          <td>{{ dateCounts.regularWorkDay }}日</td>
        </tr>
        <tr v-if="owner.few_work_days">
          <th>一般所定出社日数</th>
          <td>{{ dateCounts.calendarWorkDay }}日</td>
        </tr>
        <tr>
          <th>在宅日数</th>
          <td>{{ dateCounts.homeWorkDay || 0  }} 日</td>
        </tr>
        <tr v-if="owner.max_home_work_days">
          <th>在宅上限日数</th>
          <td>{{ owner.max_home_work_days }} 日</td>
        </tr>
      </table>
    </v-layout>
    <v-layout grid-list-md align-center>
      <paid-days-off-table />
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import PaidDaysOffTable from "@/components/Home/paidDaysOffTable";
export default {
  components: {
    PaidDaysOffTable,
  },
  data: () => ({}),
  computed: {
    ...mapGetters("timesheet", ["dateCounts", "owner"]),
  },
  created() {
    console.log("owner:", this.owner);
    console.log("max_home_work_days:", this.owner && this.owner.max_home_work_days);
  }
};
</script>
<style lang="scss" scoped>
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}
</style>

